<div class="toast-container top-right">
  @for (item of items; track item.id) {
    <div @trigger class="flex">
      @if (item.position === 'top-right') {
        <ng-container *ngTemplateOutlet="toastContent; context: { toastItem: item, margin: 'ml-auto' }"></ng-container>
      }
    </div>
  }
</div>
<div class="toast-container top-center">
  @for (item of items; track item.id) {
    <div @trigger class="flex">
      @if (item.position === 'top-center') {
        <ng-container *ngTemplateOutlet="toastContent; context: { toastItem: item, margin: 'ml-auto mr-auto' }"></ng-container>
      }
    </div>
  }
</div>
<div class="toast-container top-left">
  @for (item of items; track item.id) {
    <div @trigger class="flex">
      @if (item.position === 'top-left') {
        <ng-container *ngTemplateOutlet="toastContent; context: { toastItem: item, margin: 'mr-auto' }"></ng-container>
      }
    </div>
  }
</div>
<div class="toast-container bottom-right">
  @for (item of items; track item.id) {
    <div @trigger class="flex">
      @if (item.position === 'bottom-right') {
        <ng-container *ngTemplateOutlet="toastContent; context: { toastItem: item, margin: 'ml-auto' }"></ng-container>
      }
    </div>
  }
</div>
<div class="toast-container bottom-center">
  @for (item of items; track item.id) {
    <div @trigger class="flex">
      @if (item.position === 'bottom-center') {
        <ng-container *ngTemplateOutlet="toastContent; context: { toastItem: item, margin: 'ml-auto mr-auto' }"></ng-container>
      }
    </div>
  }
</div>
<div class="toast-container bottom-left">
  @for (item of items; track item.id) {
    <div @trigger class="flex">
      @if (item.position === 'bottom-left') {
        <ng-container *ngTemplateOutlet="toastContent; context: { toastItem: item, margin: 'mr-auto' }"></ng-container>
      }
    </div>
  }
</div>
<ng-template #toastContent let-item="toastItem" let-margin="margin">
  <div class="toast {{ item.class }} {{ margin }} shadow-lg" tabindex="0" (click)="removeItem(item.id)" (keyup.enter)="removeItem(item.id)" (keyup.space)="removeItem(item.id)">
    <div class="inline">
      <span class="mr-1 align-middle"
        ><i class="mt-1 material-icons">{{ item.icon }}</i></span
      >
    </div>
    @if (item.title) {
      <span class="mr-1 font-medium">{{ item.title }}</span>
    }
    <span class="mr-1">{{ item.message }}</span>
  </div>
</ng-template>
